/* DE01SP product page behaviour. Vanilla, no dependencies, scoped to each .dbo-de01sp root.
   BUY BOX LIVE since 2026-09-24 (CEO "GO"): Add to cart posts the DE01SP variant for the picked size x pack,
   plus its Loop selling plan when Subscribe is picked, then goes to /cart. Same flow as cpdpsm.js on cpdpp2. */
(function () {
  function init(root) {
    if (root.dataset.dsInit) return;
    root.dataset.dsInit = '1';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    // one-of-many selection helper: marks the picked element .is-on, returns its index
    function group(sel, onPick) {
      var items = $$(sel);
      items.forEach(function (el, i) {
        el.addEventListener('click', function () {
          items.forEach(function (x) { x.classList.toggle('is-on', x === el); x.setAttribute('aria-pressed', x === el ? 'true' : 'false'); });
          if (onPick) onPick(i, el);
        });
      });
    }

    // ---- gallery: desktop thumbs ----
    var main = $('.ds-gal-main img');
    group('.ds-thumb', function (i, el) { if (main) { main.src = el.querySelector('img').src; } });

    // ---- gallery: mobile slider ----
    var slider = $('.ds-slider');
    var dots = $$('.ds-gal-m .ds-dot');
    if (slider) {
      var step = function () { var f = slider.firstElementChild; return f ? f.offsetWidth + 2 : slider.clientWidth; };
      var go = function (i) { var n = Math.max(0, Math.min(slider.children.length - 1, i)); slider.scrollTo({ left: n * step(), behavior: 'smooth' }); };
      var cur = function () { return Math.round(slider.scrollLeft / step()); };
      $('.ds-arrow-p').addEventListener('click', function () { go(cur() - 1); });
      $('.ds-arrow-n').addEventListener('click', function () { go(cur() + 1); });
      slider.addEventListener('scroll', function () { var c = cur(); dots.forEach(function (d, i) { d.classList.toggle('is-on', i === c); }); }, { passive: true });
    }

    // ---- buy box: offer ladder mirrored from the LIVE /products/cpdpp2 (CEO 2026-09-24) ----
    // Size x pack x one-time/subscribe. Same numbers as build.py LADDER/DPJ; change both together.
    var DPJ = { tiny: 60, medium: 30, large: 20 };
    var LADDER = {
      tiny: { qty: [1, 2, 3], orig: [99, 198, 297], onetime: [49.97, 89.97, 119.97], subscribe: [44.97, 79.97, 99.97] },
      ml:   { qty: [1, 3, 5], orig: [99, 299, 499], onetime: [49.97, 99.96, 149.97], subscribe: [39.98, 79.97, 129.97] }
    };
    var plans = $$('.ds-plan'), weights = $$('.ds-weight'), modes = $$('.ds-po-head');
    // CPDPP2 purchase-option block (2026-09-26): one set of steps, moved into whichever card is open
    var offer = $('.ds-offer'), steps = $('.ds-steps');
    function placeSteps() {
      if (!offer || !steps) return;
      var st = idx(modes) === 0 ? 'onetime' : 'subscribe';
      offer.setAttribute('data-state', st);
      var body = offer.querySelector('.ds-po[data-option="' + st + '"] .ds-po-body');
      if (body && steps.parentNode !== body) body.appendChild(steps);
    }
    var wasEl = $('.ds-sticky-p span'), nowEl = $('.ds-sticky-p strong');
    var idx = function (list) { for (var i = 0; i < list.length; i++) if (list[i].classList.contains('is-on')) return i; return 0; };
    var money = function (n) { return '$' + n.toFixed(2); };
    function renderOffer() {
      var wEl = weights[idx(weights)], w = (wEl && wEl.dataset.weight) || 'medium';
      var L = LADDER[w === 'tiny' ? 'tiny' : 'ml'], dpj = DPJ[w] || 30;
      var mode = idx(modes) === 0 ? 'onetime' : 'subscribe';
      placeSteps();
      plans.forEach(function (card, i) {
        var days = L.qty[i] * dpj, price = L[mode][i], m = days / 30;
        card.querySelector('.ds-plan-name').textContent = dpj >= 30 ? m + ' ' + (m === 1 ? 'Month' : 'Months') + ' Supply' : days + ' Days Supply';
        card.querySelector('.ds-pd').textContent = '$' + (price / days).toFixed(2);
        card.querySelector('.ds-was').textContent = money(L.orig[i]);
        var sv = card.querySelector('.ds-save'); if (sv) { sv.textContent = 'Save $' + Math.round(L.orig[i] - price); sv.hidden = i === 0; }
        card.querySelector('.ds-now').textContent = money(price);
        var fs = card.querySelector('.ds-fs'); if (fs) fs.hidden = price < 60; // Free Shipping $60+
      });
      var p = idx(plans), pct = Math.round((L.onetime[p] - L.subscribe[p]) / L.onetime[p] * 100);
      $$('.ds-pct').forEach(function (el) { el.textContent = pct; });
      if (wasEl) wasEl.textContent = money(L.orig[p]);
      if (nowEl) nowEl.textContent = money(L[mode][p]);
      // desktop sticky bar (Pixel spec 3c): summary built only from labels already on the page
      var dwas = $('.ds-dsticky-was'), dnow = $('.ds-dsticky-now');
      // weight shows only in ADD mode (Zara gate: a PICK bar must not name a size while asking her to pick one)
      var dW = $('.ds-dsum-w'), dR = $('.ds-dsum-r');
      if (dW && wEl) dW.textContent = wEl.getAttribute('data-label') + ' \u00b7 ';
      if (dR) dR.textContent = [plans[p].querySelector('.ds-plan-name').textContent, modes[idx(modes)].getAttribute('data-short')].join(' \u00b7 ');
      if (dwas) dwas.textContent = money(L.orig[p]);
      if (dnow) dnow.textContent = money(L[mode][p]);
    }
    // ---- Add to cart (live 2026-09-24). Variant + Loop plan per size|pack, from offers-map.json. Loop plans are the
    // same ids cpdpp2 uses (verified per variant). Keys: data-weight | pack index (0 starter, 1 middle, 2 largest).
    var OFFERS = {"tiny|0": [45092721262685, 7572258909], "tiny|1": [45092721360989, 7572127837], "tiny|2": [45092721393757, 7572324445], "medium|0": [45092721295453, 4181950557], "medium|1": [45092721426525, 4181983325], "medium|2": [45092721492061, 8304984157], "large|0": [45092721328221, 4182048861], "large|1": [45092721459293, 4182081629], "large|2": [45092721524829, 8305115229]};
    function selection() {
      var wEl = weights[idx(weights)], w = (wEl && wEl.dataset.weight) || 'medium';
      var o = OFFERS[w + '|' + idx(plans)];
      return o ? { id: o[0], plan: idx(modes) === 1 ? o[1] : null } : null;
    }
    $$('button.ds-atc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sel = selection(); if (!sel) return;
        var body = { id: sel.id, quantity: 1 }; if (sel.plan) body.selling_plan = sel.plan;
        var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding...';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw new Error('cart add ' + r.status); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { btn.disabled = false; btn.textContent = label; alert('Could not add to cart. Please try again.'); });
      });
    });

    group('.ds-weight', renderOffer);
    group('.ds-plan', renderOffer);
    group('.ds-po-head', renderOffer);
    renderOffer();

    // ---- ship date: today + 2 days ----
    var ship = $('.ds-ship-date');
    if (ship) ship.textContent = new Date(Date.now() + 2 * 864e5).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });

    // ---- review avatars: random order, as in the template ----
    var av = $('.ds-rev-av');
    if (av) {
      var kids = Array.prototype.slice.call(av.children);
      for (var k = kids.length - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)); var t = kids[k]; kids[k] = kids[j]; kids[j] = t; }
      kids.forEach(function (c) { av.appendChild(c); });
    }

    // ---- accordions: one open at a time per group ----
    function accordion(itemSel, btnSel, chevOpen, chevShut) {
      var items = $$(itemSel);
      items.forEach(function (it) {
        var btn = it.querySelector(btnSel);
        btn.addEventListener('click', function () {
          var open = !it.classList.contains('is-open');
          items.forEach(function (x) {
            var on = x === it && open;
            x.classList.toggle('is-open', on);
            x.querySelector(btnSel).setAttribute('aria-expanded', on ? 'true' : 'false');
            x.querySelector('.ds-chev').textContent = on ? chevOpen : chevShut;
          });
        });
      });
    }
    accordion('.ds-tab', '.ds-tab-btn', '︿', '﹀');
    accordion('.ds-faq', '.ds-faq-btn', '︿', '›');
    // closing CTA: smooth scroll back to Step 1 (the href keeps it working without JS)
    // (also the guarantee band's CTA: every link to #ds-offer)
    // smooth in-page jumps: to Step 1 (#ds-offer) and to the reviews wall (#ds-reviews); the hrefs work without JS
    ['#ds-offer', '#ds-reviews'].forEach(function (id) {
      var t = $(id);
      if (t) $$('a[href="' + id + '"]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }); });
    });

    // ---- ingredient carousel ----
    var track = $('.ds-ing-track');
    var idots = $$('.ds-ing-dot');
    if (track) {
      var istep = function () { var f = track.firstElementChild; if (!f) return 1; return f.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0); };
      var icur = function () { return Math.round(track.scrollLeft / istep()); };
      var igo = function (i) { var n = Math.max(0, Math.min(track.children.length - 1, i)); track.scrollTo({ left: n * istep(), behavior: 'smooth' }); };
      $('.ds-ing-prev').addEventListener('click', function () { igo(icur() - 1); });
      $('.ds-ing-next').addEventListener('click', function () { igo(icur() + 1); });
      idots.forEach(function (d, i) { d.addEventListener('click', function () { igo(i); }); });
      track.addEventListener('scroll', function () { var c = icur(); idots.forEach(function (d, i) { d.classList.toggle('is-on', i === c); }); }, { passive: true });
    }

    // ---- customer photos: evergreen marquee (CEO 2026-09-24) ----
    // Moves the track left forever. The photo set is in the DOM twice, so when the offset passes one
    // set's width it wraps by exactly that width and the jump is invisible. Pauses on hover/touch,
    // stops while off screen, and stays still for prefers-reduced-motion.
    var mq = $('.ds-marquee'), mtrack = $('.ds-marquee-track');
    if (mq && mtrack) {
      var SPEED = 40; // px per second
      var half = mtrack.children.length / 2;
      var setW = 0, off = 0, last = 0, paused = false, onScreen = true, raf = 0;
      var measure = function () { var a = mtrack.children[0], b = mtrack.children[half]; setW = a && b ? b.offsetLeft - a.offsetLeft : 0; };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      var frame = function (t) {
        raf = 0;
        if (last) {
          var dt = Math.min(t - last, 100) / 1000; // clamp so a background tab does not lurch on return
          if (!paused && setW) { off -= SPEED * dt; if (off <= -setW) off += setW; mtrack.style.transform = 'translate3d(' + off + 'px,0,0)'; }
        }
        last = t;
        run();
      };
      var run = function () { if (!raf && onScreen && !(reduce && reduce.matches)) raf = requestAnimationFrame(frame); };
      var stop = function () { if (raf) cancelAnimationFrame(raf); raf = 0; last = 0; };
      mq.addEventListener('mouseenter', function () { paused = true; });
      mq.addEventListener('mouseleave', function () { paused = false; });
      mq.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      mq.addEventListener('touchend', function () { paused = false; }, { passive: true });
      window.addEventListener('resize', function () { measure(); if (setW) off = off % setW; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; if (onScreen) run(); else stop(); }).observe(mq);
      }
      if (reduce && reduce.addEventListener) reduce.addEventListener('change', function () { if (reduce.matches) stop(); else run(); });
      measure();
      run();
    }

    // ---- fixed add-to-cart bars (Quinn 2026-09-25, calls A and flag 1) ----
    // Both bars show while the main Add to cart is not fully on screen (above or below). The desktop top bar also stays up
    // while its reserved 65px slot is on screen. PICK mode (jump to Step 1) until she picks a tile, plan or mode or passes
    // the main button, then ADD mode for the rest of the page view.
    var mbar = $('.ds-sticky'), dbar = $('.ds-dsticky'), trigger = $('.ds-atc-main'), step1 = $('.ds-step-l'), tiles = $('.ds-weights');
    if (trigger && (mbar || dbar)) {
      var chosen = false, ticking = false;
      var check = function () {
        ticking = false;
        var r = trigger.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var inView = r.top >= 0 && r.bottom <= vh;
        var slotOnScreen = root.getBoundingClientRect().top > -65;
        if (r.top < 0) chosen = true; // she has scrolled past the main button's top edge: the bar buys from here on
        // PICK mode exists to get her to Step 1. While Step 1 sits in reading position (label in the top 45% of the window,
        // tiles still on screen) the PICK bar would repeat the heading under it, so it steps aside (Zara gate 2026-09-25).
        var atStep1 = false;
        if (step1 && tiles) { var s1 = step1.getBoundingClientRect(), tl = tiles.getBoundingClientRect(); atStep1 = s1.top < vh * 0.45 && tl.bottom > 0; }
        var pickAside = !chosen && atStep1;
        if (mbar) { mbar.classList.toggle('is-add', chosen); mbar.classList.toggle('is-visible', !inView && !pickAside); }
        if (dbar) { dbar.classList.toggle('is-add', chosen); dbar.classList.toggle('is-visible', (!inView || slotOnScreen) && !pickAside); }
      };
      var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      $$('.ds-weight, .ds-plan, .ds-po-head').forEach(function (el) { el.addEventListener('click', function () { chosen = true; queue(); }); });
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      check();
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.dbo-de01sp'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', boot);
})();
